import {Component, ViewChild} from '@angular/core';
import Timer = NodeJS.Timer;

@Component({
  selector: 'app-overlay-message-trailer',
  templateUrl: './overlay-message-trailer.component.html',
  styleUrls: ['./overlay-message-trailer.component.less']
})
export class OverlayMessageTrailerComponent {
  playing = false;
  forwarding = false;
  rewinding = false;
  pause = false;

  showOverlayMessage = false;
  showOverlayProgress = false;
  showOverlayPlaybackTimeout = 1000;
  showOverlayPlaybackTimerTimeout = 6000;

  videoDuration = 0;
  videoCurrent = 0;
  playedPercentage = 0;
  curTimeText = '00:00';
  durTimeText = '00:00';

  overlayPlayBackTimer: Timer;
  overlayPlayBackProgressTimer: Timer;

  @ViewChild('progressBar')
  progressBar: HTMLSpanElement;

  constructor() {
  }

  isForwarding() {
    this.resetAllBooleans();
    this.forwarding = true;
    this.displayProgress();
  }

  isRewinding() {
    this.resetAllBooleans();
    this.rewinding = true;
    this.displayProgress();
  }

  hideVideoReadyToPlay() {
    this.showOverlayMessage = false;
    this.showOverlayProgress = false;
  }

  showVideoReadyToPlay() {
    this.showOverlayMessage = true;
    this.showOverlayProgress = true;
  }

  displayProgress() {
    this.clearTimers();

    this.showOverlayProgress = true;

    this.overlayPlayBackTimer = setTimeout(() => {
      this.resetAllBooleans();
    }, this.showOverlayPlaybackTimeout);
    this.overlayPlayBackProgressTimer = setTimeout(() => {
      this.showOverlayProgress = false;
    }, this.showOverlayPlaybackTimerTimeout);
  }

  updateVideoDurationTime(duration: number) {
    this.videoDuration = duration;
    this.durTimeText = this.convertNumberToTimeNotation(duration);
  }

  updateVideoCurrentTime(currentTime: number) {
    this.videoCurrent = currentTime;
    this.curTimeText = this.convertNumberToTimeNotation(currentTime);
    this.playedPercentage = (currentTime / this.videoDuration) * 100;
  }

  private convertNumberToTimeNotation(timeNumber: number): string {
    const minutes = Math.floor(timeNumber / 60);
    const seconds = Math.floor(timeNumber % 60);

    const minutesText = minutes < 10 ? '0' + minutes : '' + minutes;
    const secondsText = seconds < 10 ? '0' + seconds : '' + seconds;

    return minutesText + ':' + secondsText;
  }

  private clearTimers(): void {
    if (this.overlayPlayBackTimer) {
      clearTimeout(this.overlayPlayBackTimer);
    }
    if (this.overlayPlayBackProgressTimer) {
      clearTimeout(this.overlayPlayBackProgressTimer);
    }
  }

  private resetAllBooleans() {
    this.rewinding = this.forwarding = this.playing = this.pause = false;
  }
}
